// const LANDING_VIEW: String = "LANDING_VIEW";
const ABOUT_VIEW: String = "ABOUT";
const PROJECTS_VIEW: String = "PROJECTS";
const SKILLS_VIEW: String = "SKILLS";
const CONTACT_VIEW: String = "CONTACT";

export const viewIDs = {
  ABOUT_VIEW,
  PROJECTS_VIEW,
  SKILLS_VIEW,
  CONTACT_VIEW,
};

export const SECTIONS: Array<String> = [
  ABOUT_VIEW,
  PROJECTS_VIEW,
  SKILLS_VIEW,
  CONTACT_VIEW,
];
